import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, CommonModule } from '@angular/common';
import { Identification, Session, Verification } from 'src/app/queries/generated';
import { IdFromGidPipe } from '@pipes/id-from-gid.pipe';

@Component({
  selector: 'lv-session-review-id',
  templateUrl: 'session-review-id.component.html',
  styleUrls: ['session-review-id.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, NgClass, IdFromGidPipe]
})
export class SessionReviewIdComponent {
  @Input() session: Session;

  get identification(): Identification {
    return this.session.activeIdentification;
  }

  get idVerifications(): Verification[] {
    return this.session.verifications.filter(
      (verification) => verification.service === 'identification' && verification.status === 'failed'
    );
  }

  verificationReasons(): string[] {
    const reasons = [];
    this.idVerifications.forEach((verification) => {
      reasons.push(verification.reason.replace(/\n/g, '<br>'));
    });

    return reasons;
  }
}
